import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PspCompanyEnum } from '../../enums/psp-company.enum';
import { IsPermissionExist } from '../../helpers/get-permissions';
import { PspEvaPermission, PspLillyPermission, PspRochePermission } from '../../_constants/permissions.constant';

@Component({
  selector: 'app-companies-select',
  templateUrl: './companies-select.component.html',
  styleUrls: ['./companies-select.component.scss']
})
export class CompaniesSelectComponent implements OnInit {
  @Output() companySelected: EventEmitter<number> = new EventEmitter();

  private permissionsMapper = {
    1: PspEvaPermission,
    2: PspLillyPermission,
    3: PspRochePermission
  };

  companies = [];
  @Input() defaultCompany = 0;
  @Input() includeAllPrograms = true;
  @Input() designClasses : string;

  constructor() {}

  ngOnInit(): void {
    this.initializeCompanies();
  }

  private initializeCompanies(): void {
    Object.keys(PspCompanyEnum)
      // To filter unwanted enum's numbered keys
      .filter(key => Number.isNaN(Number(key)))
      .filter(key => this.canView(PspCompanyEnum[key]))
      .forEach(key => this.companies.push({
        id: PspCompanyEnum[key],
        name: `${key} Programs`
      }));

    if (this.companies.length !== 0 && this.includeAllPrograms == true) {
      this.companies.unshift({
        id: 0,
        name: 'All Programs'
      });
    }
  }

  onCompanySelection(event: any): void {
    this.companySelected.emit(event.id);
  }

  canView(companyId: number): boolean {
    return IsPermissionExist(this.permissionsMapper[companyId]);
  }
}
